import api from "../utils/api";

export const getAlerts = async (username) => {
  try {
    const response = await api.get(`/alerts/${encodeURIComponent(username)}`);
    return response.data;
  } catch (error) {
    console.error("Get alerts error:", error);
    throw error;
  }
};

export const getAlertsHistory = async (username) => {
  try {
    const response = await api.get(`/alerts/history/${encodeURIComponent(username)}`);
    return response.data;
  } catch (error) {
    console.error("Get alerts history error:", error);
    throw error;
  }
};

export const markAlertsRead = async (alertIds) => {
  try {
    const response = await api.post("/alerts/mark-read", {
      alert_ids: alertIds,
    });
    return response.data;
  } catch (error) {
    console.error("Mark alerts read error:", error);
    throw error;
  }
};

// Manually resolve alerts. Pass alertIds to resolve specific ones,
// or omit to resolve all unresolved alerts for the given meter.
export const resolveAlerts = async (username, meterId, alertIds) => {
  try {
    const body = { username, meter_id: meterId };
    if (Array.isArray(alertIds) && alertIds.length > 0) {
      body.alert_ids = alertIds;
    }
    const response = await api.post("/alerts/resolve", body);
    return response.data;
  } catch (error) {
    console.error("Resolve alerts error:", error);
    throw error;
  }
};
